<div class="container mx-auto min-h-[600px]">
  <!-- Header Section -->
  <div class="flex flex-wrap items-center justify-between mb-6 pb-4 border-b border-base-300">
    <div class="flex-1">
      <h2 class="text-2xl font-bold text-base-content flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
        </svg>
        Connected Accounts
      </h2>
      <p class="text-sm text-base-content/60 mt-1">Manage your Zoom account connections</p>
    </div>
    @if(linkedAccounts.length > 0 && !isPageLoading()){
    <button
      class="daisy-btn daisy-btn-primary gap-2"
      (click)="linkNewAccount()"
    >
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
      </svg>
      Link New Account
    </button>
    }
  </div>

  <div class="flex flex-wrap gap-4">
    @if(isPageLoading()){
    <div class="flex justify-center items-center w-full h-[300px]">
      <div class="flex flex-col items-center gap-4">
        <span class="daisy-loading daisy-loading-spinner daisy-loading-lg text-primary"></span>
        <p class="text-base-content/60">Loading accounts...</p>
      </div>
    </div>
    } @else { @if(linkedAccounts.length > 0){ @for (account of linkedAccounts;
    track account; let i = $index) {
    <div class="w-full md:w-[calc(50%-0.5rem)] lg:w-[calc(33.333%-0.67rem)]">
      <black-account-card
        [provider]="account.provider"
        [accountUsername]="account.username"
        [accountUserId]="account.userId"
        [isDefault]="i === 0"
        (unlinkAccountEvent)="unlinkAccount($event)"
      ></black-account-card>
    </div>
    } } @else {
    <div class="w-full">
      <div class="daisy-card bg-base-100 border-2 border-dashed border-base-300 hover:border-primary transition-colors">
        <div class="daisy-card-body text-center py-12">
          <div class="flex justify-center mb-4">
            <div class="w-20 h-20 rounded-full bg-base-200 flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 text-base-content/40" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
              </svg>
            </div>
          </div>
          <h3 class="text-xl font-semibold mb-2">No Connected Accounts</h3>
          <p class="text-base-content/60 mb-6">Connect your Zoom account to start hosting live classes</p>
          <button
            class="daisy-btn daisy-btn-primary gap-2 mx-auto"
            (click)="linkNewAccount()"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
            </svg>
            Link Your First Account
          </button>
        </div>
      </div>
    </div>
    } }
  </div>
</div>
